export const config = {
  /** API サーバーの URL（ブラウザからアクセス） */
  apiUrl: "https://stg-api.b-faq.run",
  /** GTM コンテナ ID */
  gtmContainerId: "GTM-WHGPD9Q2",
  planCodes: {
    free: "free",
    beginner: "beginner",
    enterprise: "enterprise",
  },
  bypassPlanGate: false,
} as const;
